import React from "react";
import clsx from "clsx";
import {makeStyles} from "@material-ui/core/styles";

import {
    Toolbar,
    AppBar
} from "@material-ui/core";

import Language from "../../component/Language/language";
import NotificationDrawer from "../../component/Notification/notification";
// import QuickActions from "../../component/quickActions/QuickActions";
import HelpSection from "../../component/Help/HelpSection";
import Profile from "../../component/Profile/Profile"


import "./sideNavigationBar.css";

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
    },
    appBar: {
        backgroundColor: "var(--black-pearl)",
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        borderBottomRightRadius: 5,
        borderBottomLeftRadius: 10,
    },
    div: {
        display: "flex",
        width: "100%",
        justifyContent: "flex-end",
        marginLeft: "10px",
        alignItems: 'center'
    },
    icon: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "45px",
        height: "45px",
        borderRadius: "6px",
        "&:hover": {
            background: "rgba(128, 128, 128, 0.25)",
        },
        "&:active": {
            background: "rgba(128, 128, 128, 0.25)",
        },
        marginLeft: "10px",
    },
    icons: {
        color: "#fff",
        fontSize: "1.3rem",

    },
    profilediv: {
        display: "flex",
        justifyContent: "flex-end",
        marginLeft: "10px",
    },
    button: {
        "&:hover": {
            background: "rgba(128, 128, 128, 0.25)",
        },
    },

    span: {
        color: "white",
        marginRight: "10px",
    }
}));

function Navbar() {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <AppBar
                position="fixed"
                className={clsx(classes.appBar)}
            >
                <Toolbar>
                    <div className={classes.div}>
                        <div className={classes.icon}>
                            <NotificationDrawer/>
                        </div>
                        {/*<div className={classes.icon} >*/}
                        {/*        <QuickActions className={classes.icons} />*/}
                        {/*</div>*/}
                        <div className={classes.icon}>
                            <HelpSection className={classes.icons}/>
                        </div>
                        <div className={classes.icon}>
                            <Language/>
                        </div>
                        <div className={classes.profilediv}>
                            <Profile/>
                        </div>
                    </div>
                </Toolbar>
            </AppBar>
        </div>
    );
}

export default React.memo(Navbar)
